export default __webpack_public_path__ + "static/media/presentation.c629b729.pptx";